import { Injectable } from '@angular/core';
import { finalize } from 'rxjs';
import { NotificationService } from './notification.service';
import { QuerySettingService } from './query-setting.service';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadHelperService {

  constructor(private readonly querySettingService: QuerySettingService, private readonly notificationService: NotificationService) { }

  private downloadAndSaveFile(blob: Blob, fileName: string){
  
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url); 
    }
  
    downloadFile(file: any, onComplete?: () => void): void {
      console.log('file',file);
      const idFile = file.id;
      const fileName = file.filename;
      this.querySettingService.downloadTxt(idFile).pipe(finalize(() => { 
          if (onComplete){
            onComplete();
          }
         })).subscribe({
          next: (blob: Blob) => { 
            this.downloadAndSaveFile(blob, fileName);
            this.notificationService.successOnDownload(fileName);
          },
          error: (err: any)=> {
            console.log("errore nella richiesta", err);
            this.notificationService.errorOnDownload(fileName);
          }
         })
  
    }
}
